import HighResolutionNowcast from './mapLayers/HighResolutionNowcast'
import Landslide from './mapLayers/Landslide'
import Inundation from './mapLayers/Inundation'
import Flood, { FORECASTS as FLOOD_FORECASTS, RISKS as FLOOD_RISKS } from './mapLayers/Flood'
import FloodInundationHazardMap from './mapLayers/FloodInundationHazardMap'
import SedimentDisasterHazardMap from './mapLayers/SedimentDisasterHazardMap'
import HillShadeMap from './mapLayers/HillShadeMap'
import Boundaries from './mapLayers/Boundaries'
import MapboxTraffics from './mapLayers/MapboxTraffics'
import MapboxLabels from './mapLayers/MapboxLabels'

export const mapboxLabelsLayer = {
    key: 'mapboxLabelsLayer',
    layer: new MapboxLabels(), title: 'ラベル', isShow: false,
    legends: []
}

export const boundariesLayer = {
    key: 'boundariesLayer',
    layer: new Boundaries(), title: '行政界', isShow: false,
    legends: []
}

export const landslideLayer = {
    key: 'landslideLayer',
    layer: new Landslide(), title: 'キキクル（土砂災害）', isShow: false,
    legends: [
        {
            id: 'キキクル（土砂災害）',
            position: { x: 0, y: 0 },
            unit: "土砂災害 危険度",
            items: [
                { value: '注意', color: '#f2e700' },
                { value: '警戒', color: '#ff2800' },
                { value: '危険', color: '#e62dff' },
                { value: '災害切迫', image: './images/landslide-legends-4.png' },
            ]
        }
    ]
}

export const inundationLayer = {
    key: 'inundationLayer',
    layer: new Inundation(), title: 'キキクル（浸水害）', isShow: false,
    legends: [
        {
            id: 'キキクル（浸水害）',
            position: { x: 0, y: 0 },
            unit: "浸水害 危険度",
            items: [
                { value: '注意', color: '#f2e700' },
                { value: '警戒', color: '#ff2800' },
                { value: '危険', color: '#e62dff' },
                { value: '災害切迫', image: './images/inundation-legends-4.png' },
            ]
        }
    ]
}

export const floodLayer = {
    key: 'floodLayer',
    layer: new Flood(), title: 'キキクル（洪水害）', isShow: false,
    legends: [
        {
            id: 'キキクル（洪水害） 指定河川洪水予報',
            position: { x: 0, y: -215 },
            unit: "指定河川洪水予報",
            items: [
                { value: '氾濫注意情報', color: 'rgb(250, 245, 0)' },
                { value: '氾濫警戒情報', color: 'rgb(255, 90, 0)' },
                { value: '氾濫危険情報', color: 'rgb(230, 11,108)' },
                { value: '氾濫発生情報', color: 'rgb(0, 0, 0)' },
            ]
        },
        {
            id: 'キキクル（洪水害） 危険度',
            position: { x: 0, y: 0 },
            unit: "洪水害 危険度",
            items: [
                { value: '注意', color: '#FAF500' },
                { value: '警戒', color: '#FA4500' },
                { value: '危険', color: '#6C008C' },
                { value: '災害切迫', color: '#000000' },
            ]
        }
    ]
}

export const highResolutionNowcastLayer = {
    key: 'highResolutionNowcastLayer',
    layer: new HighResolutionNowcast(), title: '高解像度降水ナウキャスト', isShow: false,
    legends: [
        {
            id: '高解像度降水ナウキャスト',
            position: { x: 0, y: 0 },
            unit: "mm/h",
            items: [
                { value: 0, color: '#A8A8B1' },
                { value: 1, color: '#7795B0' },
                { value: 5, color: '#2C6BB0' },
                { value: 10, color: '#173EB0' },
                { value: 20, color: '#ADAA18' },
                { value: 30, color: '#B17318' },
                { value: 50, color: '#B12F17' },
                { value: 80, color: '#831757' },
            ]
        }
    ]
}

export const mapboxTrafficsLayer = {
    key: 'mapboxTrafficsLayer',
    layer: new MapboxTraffics(), title: '交通', isShow: false,
    legends: []
}

export const floodInundationHazardMapLayer = {
    key: 'floodInundationHazardMapLayer',
    layer: new FloodInundationHazardMap(), title: '洪水害ハザードマップ（岩手県）', isShow: false,
    legends: [
        {
            id: '洪水害ハザードマップ 浸水深',
            position: { x: 0, y: -185 },
            unit: "浸水深",
            items: [
                { value: '0.5m未満', color: 'rgb(247, 245, 169)' },
                { value: '0.5〜3.0m', color: 'rgb(255, 216, 192)' },
                { value: '3.0〜5.0m', color: 'rgb(255, 183, 183)' },
                { value: '5.0〜10.0m', color: 'rgb(255, 145, 145)' },
                { value: '10.0〜20.0m', color: 'rgb(242, 133, 201)' },
                { value: '20.0m以上', color: 'rgb(220, 122, 220)' },
            ]
        },
        {
            id: '洪水害ハザードマップ 家屋倒壊等氾濫想定区域',
            position: { x: 0, y: 0 },
            unit: "家屋倒壊などの危険がある区域",
            items: [
                { value: '氾濫流によって家屋倒壊等の危険', image: './images/house-1.png' },
                { value: '河岸侵食によって家屋倒壊等の危険', image: './images/house-2.png' },
                { value: '早期の立退き避難が必要', image: './images/house-3.png' },
            ]
        }
    ]
}

export const sedimentDisasterHazardMapLayer = {
    key: 'sedimentDisasterHazardMapLayer',
    layer: new SedimentDisasterHazardMap(), title: '土砂災害ハザードマップ（岩手県）', isShow: false,
    legends: [
        {
            id: '土砂災害ハザードマップ',
            position: { x: 0, y: 0 },
            unit: "土砂災害",
            items: [
                { value: '地すべり危険箇所', image: './images/hazard_area_7.png' },
                { value: '急傾斜地崩壊危険箇所', image: './images/hazard_area_5.png' },
                { value: '土石流危険区域', image: './images/hazard_area_2.png' },
                { value: '地すべり 警戒区域', image: './images/warning_area_3.png' },
                { value: '地すべり 特別警戒区域', image: './images/warning_area_6.png' },
                { value: '急傾斜地の崩壊 警戒区域', image: './images/warning_area_1.png' },
                { value: '急傾斜地の崩壊 特別警戒区域', image: './images/warning_area_4.png' },
                { value: '土石流 警戒区域', image: './images/warning_area_2.png' },
                { value: '土石流 特別警戒区域', image: './images/warning_area_5.png' },
            ]
        }
    ]
}

export const hillShadeMapLayer = {
    key: 'hillShadeMapLayer',
    layer: new HillShadeMap(), title: '地理院地図 陰影起伏図', isShow: false,
    legends: []
}
